function main() {
  require('./output/Main').main();
}

main();
